import { WrapperAutoDescubrimiento } from './styles';
import Transacciones from './Transacciones';
import TransaccionesSalud from './TransaccionesSalud';
import Locaciones from './Locaciones';
import AlertaTransacciones from './AlertaTransacciones';

const Index = () => {
  return (
    <WrapperAutoDescubrimiento>
      <div className="wrapper-transac">
        <section className="flex-col bg-white m-10 rounded-lg mt-0 w-2/4">
          <Transacciones />
        </section>
        <section className="flex-col bg-white m-10 rounded-lg mt-0 w-2/4">
          <TransaccionesSalud />
        </section>
      </div>
      <div className="wrapper-transac">
        <section className="flex-col bg-white m-10 rounded-lg mt-0 w-2/4">
          <Locaciones />
        </section>
        <section className="flex-col bg-white m-10 rounded-lg mt-0 w-2/4">
          <AlertaTransacciones />
        </section>
      </div>
    </WrapperAutoDescubrimiento>
  );
};

export default Index;
